import { useEffect, useState } from "react";
import TrainingService from "../Service/TrainingService";
import GetAllArticleView from "../Vue/Pages/GetAllArticleView";
import BlogService from "../Service/BlogService";
import ArticleModel from "../Model/ArticleModel";
import Header from "../Vue/Components/Header";

const GetAllArticleController = () => {
  const [articleData, setArticleData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArticles();
  }, [])

  const fetchArticles = async () => {
    try {
      let response = await BlogService.fetchArticles();
      let articles = await Promise.all(response.data.map(async (article) => {
        let articleModel = new ArticleModel();
        articleModel.id = article.id;
        articleModel.title = article.title;
        articleModel.content = article.content;
        articleModel.date = article.date;

        // Fetch image data
        articleModel.images = article.images[0].replace('/api/imagess', '/api/images/display');

        return articleModel; // Return the constructed article model
      }));

      setArticleData(articles); // Set the complete articles array
    } catch (error) {
      console.log("Erreur: " + error);
    } finally {
      setLoading(false); // Set loading to false after fetching data
    }
  }
  return (GetAllArticleView(articleData, loading))
}

export default GetAllArticleController;